export default __webpack_public_path__ + "static/support-57d6afd51d3428b9f845737190b04e54.png";